<template>
  <div class="int-done-wrap">
    <div class="int-done">
      <img
        class="int-done-image mb-5 mb-md-7 mx-auto"
        src="../../../assets/img/rabota/int-done.svg"
        alt=""
      >
      <h1 class="int-done-head mb-2">
        {{ $t('h1') }}
      </h1>
      <div class="int-done-text mb-2 mb-md-3">
        {{ $t('text1', { domain: appDomain }) }}
      </div>
      <div class="int-done-text mb-8 mb-md-10">
        {{ $t('text2') }}
      </div>
      <VBtn
        @click="goToVacancies"
        width="15rem"
        depressed
        color="#1FC57F"
      >
        {{ $t('goToVacancies') }}
      </VBtn>
    </div>
  </div>
</template>

<script>
import Vacancy from '@/orm/models/Vacancy/Vacancy';
import useUser from '@/compositions/useUser';
import useValidation from '@/compositions/useValidation';
import { APP_DOMAIN } from '@/helpers/constants';

export default {
  name: 'IntegrationsWizardDone',
  setup(_, { root }) {
    const { company } = useUser();
    const { withApiErrorHandling, errorMessage } = useValidation();

    withApiErrorHandling(async () => {
      await Vacancy.api().fetchAllByCompanyId(company.value.id);
    }, (e) => {
      this.errorMessage = e.message;
    });

    function goToVacancies() {
      return root.$router.push({
        name: 'vacancies',
      });
    }

    return {
      errorMessage,
      goToVacancies,
      appDomain: APP_DOMAIN,
    };
  },
};
</script>

<style lang="scss" scoped>
  .int-done-wrap {
    position: relative;
    //height: calc(100vh - 2.5rem);
  }
  .int-done {
    width: 33rem;
    max-width: 100%;
    //position: absolute;
    //left: 50%;
    //top: 50%;
    //transform: translate(-50%, -50%);
    text-align: center;
    padding: 5rem 0.75rem 0;
    margin: 0 auto;
  }
  .int-done-text {
    font-size: 1.0625rem;
    line-height: 1.53;
    color: #091A35;
  }
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    .int-done-wrap {
      //height: calc(100vh - 4rem);
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .int-done {
      padding: 3rem 0.75rem 0;
    }
    .int-done-image {
      max-width: 3.75rem;
    }
    .int-done-head {
      font-size: 1.75rem;
    }
    .int-done-text {
      font-size: 1rem;
    }
  }

</style>

<i18n locale="ru" lang="yml">

</i18n>

<i18n locale="en" lang="yml">
  h1: Почти готово!
  text1: 'Вы создали аккаунт на сервисе Huntica. Здесь вы сможете отправлять кандидатам, откликнувшимся на Работе.ру,
  приглашения на видеособеседования и просматривать видеоотклики. Рекомендуем добавить сайт {domain} в закладки.'
  text2: 'На следующем шаге вам необходимо выбрать вопросы для видео-собеседований для импортированных вакансий.'
  goToVacancies: Далее
</i18n>
